const Schedule = require('./schedule');

const Region = require('./region');

const STATES = {
  APPROVED: 'APPROVED',
  PENDING: 'PENDING',
  DECLINED: 'DECLINED'
};
/*:: type OffersInitArgs = {
  id?: string,
  businessId?: string,
  propertyId?: string,
  slug: string,
  headline: string,
  subHeadline: string,
  details: string,
  legal: string,
  keywords?: Array<string>,
  heroImage?: ?string,
  heroImages?: Array<string>,
  heroImageUrl?: ?string,
  flowId?: ?string,
  promoCode?: ?string,
  flags?: ?Array<string>,
  enabled?: ?boolean,
  shareUri?: ?string,
  shareUrl?: ?string,
  syndicated?: ?boolean,
  hasStats?: ?boolean,
  priority?: ?number,
  // search fields
  business?: ?Object,
  locationIds?: ?Array<string>,
  locations?: ?Array<Object>,
  visibleSchedules?: ?Array<Object>,
  discoverableSchedules?: ?Array<Object>,
  usableSchedules?: ?Array<Object>,
  status?: ?string,
  scheduleIds?: ?Array<string>,

  // Separate models in the API
  // TODO: Move to OfferEdit class
  tags?: Array<string>,
  schedules?: ?Array<Schedule>,
  discoverableRegions?: ?Array<string>,
  redeemableRegions?: ?Array<string>,
  flow?: Object,
  canEdit?: boolean
};*/

class Offer {
  /* :: static STATES: Object */
  constructor({
    /*: OffersInitArgs*/

    id,
    businessId,
    business,
    propertyId,
    slug,
    headline,
    headlineLocalized = {},
    subHeadline,
    subHeadlineLocalized = {},
    details,
    detailsLocalized = {},
    legal,
    legalLocalized = {},
    keywords = [],
    heroImage,
    heroImages,
    heroImageUrl,
    heroImageUrls,
    flowId,
    promoCode,
    flags,
    tags,
    status,
    schedules,
    scheduleIds,
    visibleSchedules,
    discoverableSchedules,
    usableSchedules,
    enabled,
    shareUri,
    shareUrl,
    syndicated,
    hasStats,
    priority,
    rating,
    locations,
    locationIds
  }) {
    this.id = id;
    this.businessId = businessId;
    this.business = business;
    this.propertyId = propertyId;
    this.slug = slug;
    this.headline = headline;
    this.headlineLocalized = headlineLocalized;
    this.subHeadline = subHeadline;
    this.subHeadlineLocalized = subHeadlineLocalized;
    this.details = details;
    this.detailsLocalized = detailsLocalized;
    this.legal = legal;
    this.legalLocalized = legalLocalized;
    this.keywords = keywords;
    this.heroImage = heroImage;
    this.heroImages = heroImages;
    this.heroImageUrl = heroImageUrl;
    this.heroImageUrls = heroImageUrls;
    this.flowId = flowId;
    this.promoCode = promoCode;
    this.flags = flags;
    this.tags = tags;
    this.status = status;
    this.schedules = schedules;
    this.scheduleIds = scheduleIds;
    this.visibleSchedules = visibleSchedules;
    this.discoverableSchedules = discoverableSchedules;
    this.usableSchedules = usableSchedules;
    this.enabled = enabled;
    this.shareUri = shareUri;
    this.shareUrl = shareUrl;
    this.syndicated = syndicated;
    this.hasStats = hasStats;
    this.priority = priority;
    this.rating = rating;
    this.locations = locations;
    this.locationIds = locationIds;
  }

}

Offer.STATES = STATES;
module.exports = Offer;